import styles from './DropDownWithPrice.module.scss';

type DropDownWithPriceProps = {
  ticketPrice: string,
  setQty?: {
    (qty: number): void;
  }
  type?: string
  qty?: number
}

export function DropDownWithPrice({ticketPrice, setQty, type, qty}: DropDownWithPriceProps) {

  if (!(+ticketPrice > 0)) return null

  const options = [1, 2, 3, 4, 5, 6, 7, 8, 9]

  switch (type) {
    case 'Adult':
      type = 'Adult 10+ Years'
      break
    case 'Child':
      type = 'Child 3-9 Years'
      break
    case 'General':
      type = 'General 10yrs+'
  }

  function handleChange(e: React.ChangeEvent<HTMLSelectElement>) {
    setQty ? setQty(e.target.value as unknown as number) : null
  }

  return (
    <div className={styles.selectWrap} data-testid='dropdown'>
        <select onChange={handleChange} value={qty} name="ticket-quantity" id="ticket-quantity" data-testid={`${type}-select`}>
          <option value="0">0</option>
          {options.map((option, index) => {
            return (
              <option key={index} value={option}>{option}</option>
              )
            })}
        </select>
        <label htmlFor="ticket-quantity">{type} <span className={styles.price}>£{ticketPrice}</span></label>
    </div>
  )
}